export default {
  typesContainerStyle: {
    display: "flex",
    justifyContent: "start",
  },

  baseTypeStyle: {
    fontFamily: "roboto",
    color: "white",
    padding: "0.25rem",
    width: "40%",
    textAlign: "center" as "center",
    borderRadius: "15%",
    margin: "0.5rem",
  },
};
